import { createContext, ReactNode, useState } from 'react';
import { AvatarFilter, AvatarFilterDeprecated } from '../../hooks';

export interface AvatarListPageContextType {
    search: string;
    setSearch: (search: string) => void;
    filter: AvatarFilter | AvatarFilterDeprecated;
    setFilter: (filter: AvatarFilter | AvatarFilterDeprecated) => void;
    filtersHidden: boolean;
    setFiltersHidden: (hidden: boolean) => void;
    generateModalOpen: boolean;
    setGenerateModalOpen: (open: boolean) => void;
}

export const AvatarListPageContext = createContext<AvatarListPageContextType>({
    search: '',
    setSearch: () => {},
    filter: AvatarFilter.All,
    setFilter: () => {},
    filtersHidden: false,
    setFiltersHidden: () => {},
    generateModalOpen: false,
    setGenerateModalOpen: () => {},
});

export const AvatarListPageContextProvider = ({ children }: { children: ReactNode }) => {
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState<AvatarFilter | AvatarFilterDeprecated>(AvatarFilter.All);
    const [filtersHidden, setFiltersHidden] = useState(false);
    const [generateModalOpen, setGenerateModalOpen] = useState(false);

    return (
        <AvatarListPageContext.Provider
            value={{
                search,
                setSearch,
                filter,
                setFilter,
                filtersHidden,
                setFiltersHidden,
                generateModalOpen,
                setGenerateModalOpen,
            }}>
            {children}
        </AvatarListPageContext.Provider>
    );
};
